interface Point {
  x: number;
  y: number;
}

/**
 * Draw a polygon on a canvas. A polygon is actually represented as a list of closed paths so we can account for holes in the polygon (ex. a donut).
 */
export const drawPolygon = (polygon: Point[][], ctx: CanvasPath) => {
  for (let polyIdx = 0; polyIdx < polygon.length; polyIdx++) {
    ctx.moveTo(polygon[polyIdx][0].x, polygon[polyIdx][0].y);
    for (let pointIdx = 1; pointIdx < polygon[polyIdx].length; pointIdx++) {
      ctx.lineTo(polygon[polyIdx][pointIdx].x, polygon[polyIdx][pointIdx].y);
    }
    ctx.closePath();
  }
};
